module.exports = __webpack_public_path__ + "img/IMG_20200103_164329_Bokeh - Salman Ahmad 19mvb31.781b6923.jpg";